export const PROD_HOSTNAME = 'prenuvo.com' as const;

export const SUBDOMAIN_API_MAP = {
  dev1: 'DEV_API',
  stg1: 'STAGING_API',
  'stg1-cutover': 'STAGING_API',
  na1: 'PROD_API',
  [PROD_HOSTNAME]: 'PROD_API',
} as const;
